import { useTranslate } from '@repo/shared/hooks'
import { z } from 'zod'

export const useAddShebaSchema = () => {
  const { t } = useTranslate()

  const validationRules = {
    pattern: /[0-9]{2}([0-9]{3})[0-9]{19}/,
  }

  const addShebaSchema = z.object({
    shebaNumber: z
      .string({
        required_error: t('addCardPage_shebaNumber_required'),
      })
      .regex(validationRules.pattern, t('addCardPage_shebaNumber_invalid')),
  })

  return {
    addShebaSchema,
    validationRules,
  }
}
